module.exports = __webpack_public_path__ + "static/media/art7.566c2b1c.png";